import gql from 'graphql-tag';

export default gql`
  mutation addRelatedProject($master: Int!, $related: Int!) {
    relatedProjectAdd(master: $master, related: $related)
  }
`;
